'use strict';

module.exports = require('./Autowhatever').default;


//////////////////
// WEBPACK FOOTER
// ../react-autowhatever/dist/index.js
// module id = 1529
// module chunks = 22